import {
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from "@chakra-ui/modal";
import Button from "components/button/Button";
import React from "react";

interface IUpdateConfirmationProps {
  header: string;
  body: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
}

const UpdateConfirmation: React.FC<IUpdateConfirmationProps> = (props) => {
  const { header, body, onCancel, onConfirm } = props;

  return (
    <div>
      <ModalHeader>{header}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        {" "}
        <div className="flex gap-3">
          <Button
            size="fit"
            children="Batal"
            variant="gray"
            onClick={onCancel}
          />
          <Button
            size="fit"
            children={<span className="text-white">Perbarui</span>}
            variant="primary"
            onClick={() => {
              onConfirm();
              onCancel();
            }}
          />
        </div>
      </ModalFooter>
    </div>
  );
};

export default UpdateConfirmation;
